import { CarrierAccount } from "@redotech/redo-model/carrier-account/carrier-account";
import { CreateCarrierAccount } from "@redotech/redo-model/carrier-account/create-carrier-account";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createCarrierAccount = {
  name: "createCarrierAccount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    carrierAccount: CreateCarrierAccount,
  }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
